module.exports = __webpack_public_path__ + "static/media/UserCircle.0e33e5be.svg";